import { SET_TAGS } from './types';

export default {
  [SET_TAGS](state, tags) {
    state.tags = tags;
  }
};
